import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_TYPE } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

const ACTION_SIDEBAR = 'action_sidebar';

// https://dataportal.zillowgroup.net/event-registry/3369
export const INVITE_TO_APPLY_SIDEBAR_BUTTON_CLICK_EVENT_TYPE_ID = '3369';
export const emitInviteToApplySidebarButtonClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: INVITE_TO_APPLY_SIDEBAR_BUTTON_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'invite_to_apply_button',
      trigger_object_nm: ACTION_SIDEBAR,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.InviteToApply,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3371
export const CONTACT_INFO_CALL_ICON_CLICK_EVENT_TYPE_ID = '3371';
export const emitContactInfoCallIconClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: CONTACT_INFO_CALL_ICON_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'contact_info_call_link',
      trigger_object_nm: ACTION_SIDEBAR,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ContactRachel,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3372
export const CONTACT_INFO_COPY_EMAIL_CLICK_EVENT_TYPE_ID = '3372';
export const emitContactInfoCopyEmailClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: CONTACT_INFO_COPY_EMAIL_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'contact_info_copy_email_link',
      trigger_object_nm: ACTION_SIDEBAR,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ContactRachel,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3379
export const ATTACHMENT_SIDEBAR_DOWNLOAD_CLICK_EVENT_TYPE_ID = '3379';
export const emitAttachmentSidebarDownloadClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: ATTACHMENT_SIDEBAR_DOWNLOAD_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'renter_profile_attachment_download_click',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.DownloadAttachments,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3380
export const ATTACHMENT_SIDEBAR_PREVIEW_CLICK_EVENT_TYPE_ID = '3380';
export const emitAttachmentSidebarPreviewClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: ATTACHMENT_SIDEBAR_PREVIEW_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'renter_profile_attachment_preview_click',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewAttachments,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });
